import { provincesSelectors } from "./Slice";
export const allProvincesSelector = (state) => provincesSelectors.selectAll(state.provinces);
export const provinceByIdSelector = (state) => provincesSelectors.selectById(state.provinces, state.auth.provinceId);
export const provinceByIdSelector1 = (state, id) => provincesSelectors.selectById(state.provinces, id);
